import useUserSettings from 'src/hooks/users/useUserSettings';
import useIsAdvancedSearchActive from 'src/hooks/discovery/useIsAdvancedSearchActive';
import { getEntityTypeLabel } from 'src/utils/getEntityTypeLabel';

/**
 * Returns the noun for Discovery results ("Provider(s)" / "Site(s)", or
 * "Result(s)" under an AI search) so the results panel's count header, footer
 * and empty states stay consistent.
 *
 * An AI search decides its own entity type and the Discovery panel hides the
 * Type toggle while one is applied, so the stored `prospectType` may be stale
 * from an earlier search. The backend doesn't expose a reliable entity type for
 * an AI search, so we use a generic label rather than guess (STR-983).
 *
 * @param form - 'singular' or 'plural'.
 */
const useDiscoveryEntityTypeLabel = (form: 'singular' | 'plural'): string => {
  const { settings } = useUserSettings();
  const isAdvancedSearchActive = useIsAdvancedSearchActive();

  if (isAdvancedSearchActive) {
    return form === 'singular' ? 'Result' : 'Results';
  }

  // 'C' is the Sites prospect type; anything else (including unset) is HCP.
  return getEntityTypeLabel(settings?.prospectType !== 'C', form);
};

export default useDiscoveryEntityTypeLabel;
